import { render, staticRenderFns } from "./ApartmentCards.vue?vue&type=template&id=a2a256ec&scoped=true&"
import script from "./ApartmentCards.vue?vue&type=script&lang=js&"
export * from "./ApartmentCards.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentCards.vue?vue&type=style&index=0&id=a2a256ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a256ec",
  null
  
)

export default component.exports